var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SignForm',{attrs:{"is-reset-password":true,"status":_vm.status},on:{"submit":_vm.resetPassword}}),_c('success-modal',{attrs:{"is-active":_vm.status === 'success'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }